const isFileSupportedByChannel = (
    channel: string,
    isManychatApi: boolean,
) => (file: File, acceptedFormats: string) => {
    if (!isManychatApi) return true;
    if (!acceptedFormats) return false;
    const isValidMimeType = acceptedFormats.split(',').some(
        (mimeType) => {
            const [type, subtype] = mimeType.split('/');
            if (subtype === '*') return file.type.startsWith(type);
            return file.type === mimeType;
        },
    );

    if (channel === 'facebook' && !file.type.startsWith('image')) {
        return isValidMimeType && file.size < 25 * 1024 * 1024; // 25mb
    }

    return isValidMimeType;
};

export default isFileSupportedByChannel;
